import { Injectable } from '@angular/core';
import { CurrentHoldTimesData } from './current-hold-times.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class CurrentHoldTimesService {
    dataObj: CurrentHoldTimesData = null;

    constructor(private cvApiService: CVApiService) { }

    public async loadCurrentHoldTimes(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/currentholdtimes/`
                +`${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<CurrentHoldTimesData>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    }
}
